import React, { useRef, useState, useEffect } from "react";
import { Input, Button, FormGroup, Label, Row, Col } from 'reactstrap';
import { Formik } from 'formik';
import useAxios from 'hooks/useAxios';
import ReactStrapTable from 'components/reactStrapTable';
import { patientProviderMapColumns } from 'utils/columns';
import NPIProviderList from "components/NPIProviderList";
import PatientList from "components/PatientList";
import { cloneDeep } from 'lodash';
import { getUpdatedFilter } from 'utils/helper';
import { toast } from "react-toastify";

let initialFilters = {
    currentPage: 1,
    pageSize: 10,
    orderBy: 'createdDate',
    order: 'desc',
    filters: [],
};

const relationShipOpt = [
    { id: 'N', label: 'Yes' },
    { id: 'Y', label: 'No' },
];

const PatientProviderMap = ({ selectedCoveredEntity }) => {
    const API = useAxios();
    const formikRef = useRef();
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const { tenantID, coveredEntityID } = selectedCoveredEntity;
    const [relationship, setRelationship] = useState(null);
    const [state, updateState] = useState({
        data: [],
        coveredEntity: [],
        loading: false,
        selectedEntity: '',
        coveredId: '',
        records: 0,
        reset: false,
    });

    const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

    useEffect(() => {
        initialFilters = {
            currentPage: 1,
            pageSize: 10,
            orderBy: 'modifiedDate',
            order: 'desc',
            filters: [],
        };
        fetchPatientProviderMapData();
    }, []);

    const fetchPatientProviderMapData = async () => {
        setState({
            data: [],
            records: 0,
            loading: false,
        });

        initialFilters = {
            currentPage: initialFilters.currentPage,
            pageSize: initialFilters.pageSize,
            orderBy: initialFilters.orderBy,
            order: initialFilters.order,
            filters: [],
        };
        if (selectedPatient) {
            initialFilters.filters = getUpdatedFilter(
                'patientID',
                parseInt(selectedPatient.id),
                initialFilters
            );
        }
        if (selectedProvider) {
            initialFilters.filters = getUpdatedFilter(
                'providerID',
                parseInt(selectedProvider.id),
                initialFilters
            );
        }
        if (relationship) {
            initialFilters.filters = getUpdatedFilter(
                'inActiveFlag',
                relationship,
                initialFilters
            );
        }
        let result = await API.post(`/${tenantID}/ceprovider/patientprovidermap/${coveredEntityID}`, initialFilters
        );
        if (result) {
            setState({
                data: result.data.items,
                records: result.data.totalRecords,
                loading: false,
            });
        }
        else {
            setState({
                data: [],
                records: 0,
                loading: false,
            });
        }
    };
    const onSelect = (provider) => {
        if (provider) {
            setSelectedProvider(provider);
        } else {
            setSelectedProvider(null);
        }
    };
    const onSelectPatient = (patient) => {
        if (patient) {
            setSelectedPatient(patient);
        } else {
            setSelectedPatient(null);
        }
    };
    let copyCommonColumns = cloneDeep(patientProviderMapColumns);
    let columns = [
        {
            dataField: 'edit',
            text: 'Options',
            width: 80,
            show: true,
            disabled: true,
            hideColFilter: true,
            action: true,
            cellRenderer: (row) => renderMappedOption(row),
        },
        ...copyCommonColumns,
    ];
    const renderMappedOption = (row) => {
        return (
            <FormGroup switch>
                <Input
                    type="switch"
                    id='isinactive'
                    name='isinactive'
                    onChange={(e) => handleChange(e, row.patientProviderMapID)}
                    defaultChecked={(row.inActiveFlag == "N" ? true : false)}
                />
            </FormGroup>
        );
    };

    const handleChange = async (e, patientProviderMapID) => {
        let payload = {};
        payload.PatientProviderMapID = patientProviderMapID;
        payload.inActiveFlag = e.target.checked ? "N" : "Y";

        let result = await API.post(`/${tenantID}/ceprovider/updatepatientprovidermap/${coveredEntityID}`, payload
        );
        if (result) {
            toast.success("Item updated successfully.")
            fetchPatientProviderMapData();
        }

    }

    const handleSearch = () => {
        initialFilters.currentPage = 1;
        fetchPatientProviderMapData();
    };

    const handleReset = ({ resetForm }) => {
        setSelectedPatient(null);
        setSelectedProvider(null);
        setRelationship("");
    };

    const handleChangeRelationShip = (e) => {
        setRelationship(e.target.value);
    }

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        initialFilters.currentPage = filter.currentPage;
        initialFilters.pageSize = filter.pageSize;
        fetchPatientProviderMapData();
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        initialFilters.currentPage = filter.currentPage;
        fetchPatientProviderMapData();
    };

    return (
        <>
            <Formik
                innerRef={formikRef}
                enableReinitialize={true}
                children={(props) => {
                    return (
                        <div>
                            <Row sm={5}>
                                <Col md={3} sm={3} xs={6}>
                                    <FormGroup>
                                        <Label>NPI/Provider Name</Label>
                                        <NPIProviderList
                                            tenantID={selectedCoveredEntity.tenantID}
                                            onSelect={onSelect}
                                            selectedProvider={selectedProvider}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={3} sm={3} xs={6}>
                                    <FormGroup>
                                        <Label for='patientID'>Patient Name</Label>
                                        <PatientList
                                            tenantID={tenantID}
                                            onSelect={onSelectPatient}
                                            selectedPatient={selectedPatient}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Label for="relationship">Relationship</Label>
                                        <Input
                                            id="relationship"
                                            name="relationship"
                                            type='select'
                                            onChange={(e) => handleChangeRelationShip(e)}
                                            value={relationship}
                                        >
                                            <option value={''}>--Select--</option>
                                            {relationShipOpt.map((status) => {
                                                const { id, label } = status;
                                                return (
                                                    <option key={id} value={id}>
                                                        {label}
                                                    </option>
                                                );
                                            })}
                                        </Input>
                                    </FormGroup>

                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label>{""}</Label>
                                        <Button
                                            style={{ "margin-top": "27px" }}
                                            onClick={handleSearch}
                                            color='primary'
                                            className='ms-3'
                                        >
                                            Search
                                        </Button>
                                        <Button style={{ "margin-top": "27px" }} color='primary' onClick={() => handleReset(props)}>
                                            Reset
                                        </Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div
                                        className='table-card scroll-table position-relative border-0 rounded pt-0'
                                        fixed-height={state.data.length > 0 ? 'fixed-height' : 'default'}
                                    >
                                        <ReactStrapTable
                                            id='invoicedetail-table'
                                            fixedColumn
                                            data={state.data}
                                            columns={columns}
                                            pageSize={initialFilters.pageSize}
                                            hasPagination
                                            onPageSizeChange={onPageSizeChange}
                                            currentPage={initialFilters.currentPage}
                                            totalRecords={state.records}
                                            onPageChange={onHandlePageChange}
                                            datafilter={true}

                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    );
                }}
            ></Formik>
        </>
    );
}

export default PatientProviderMap;